module.exports = __webpack_public_path__ + "img/paper_download.b2f641ae.svg";